/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {VAuth} from '../../../../../pages/auth/core/Auth'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      {/* <SidebarMenuItem
        to='/example'
        icon='/media/icons/duotune/art/art002.svg'
        title={'Example'}
        fontIcon='bi-app-indicator'
      /> */}

      <VAuth>
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />
      </VAuth>
       <VAuth>
        <SidebarMenuItem
          to='/dashboard2'
          icon='/media/icons/duotune/art/art002.svg'
            title='Dashboard Survey'
          fontIcon='bi-app-indicator'
        />
      </VAuth>
      {/* <SidebarMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      /> */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Main</span>
        </div>
      </div>
      {/* <VAuth>
        <SidebarMenuItem
          to='/assets_combine'
          icon='/media/icons/duotune/coding/cod001.svg'
          title='Master Car'
          fontIcon='bi-layers'
        />
      </VAuth> */}
      {/* <VAuth>
        <SidebarMenuItem
          to='/banner'
          icon='/media/icons/duotune/coding/cod003.svg'
          title='Banner'
          fontIcon='bi-layers'
        />
      </VAuth> */}
      <VAuth>
        <SidebarMenuItem
          to='/orders'
          icon='/media/icons/duotune/coding/cod002.svg'
          title='Order'
          fontIcon='bi-layers'
        />
      </VAuth>
      {/* <VAuth>
        <SidebarMenuItem
          to='/debitur'
          icon='/media/icons/duotune/coding/cod003.svg'
          title='Debitur'
          fontIcon='bi-layers'
        />
      </VAuth> */}
      <VAuth>
        <SidebarMenuItem
          to='/branch'
          icon='/media/icons/duotune/coding/cod004.svg'
          title='Branch'
          fontIcon='bi-layers'
        />
      </VAuth>
      <VAuth>
        <SidebarMenuItem
          to='/showroom'
          icon='/media/icons/duotune/coding/cod005.svg'
          title='Showroom'
          fontIcon='bi-layers'
        />
      </VAuth>

      {/* <VAuth>
        <SidebarMenuItem
          to='/master_survey'
          icon='/media/icons/duotune/coding/cod006.svg'
          title='Master Survey'
          fontIcon='bi-layers'
        />
      </VAuth> */}
      {/* <VAuth>
        <SidebarMenuItem
          to='/supplier'
          icon='/media/icons/duotune/coding/cod006.svg'
          title='Supplier'
          fontIcon='bi-layers'
        />
      </VAuth> */}

      <VAuth>
        <SidebarMenuItem
          to='/report_order'
          icon='/media/icons/duotune/coding/cod006.svg'
          title='Report Survey'
          fontIcon='bi-layers'
        />
      </VAuth>

        {/* <VAuth>
        <SidebarMenuItem
          to='/survey'
          icon='/media/icons/duotune/coding/cod006.svg'
          title='Survey'
          fontIcon='bi-layers'
        />
      </VAuth> */}

      <VAuth>
        <SidebarMenuItem
          to='/visit'
          icon='/media/icons/duotune/coding/cod006.svg'
          title='Visit'
          fontIcon='bi-layers'
        />
      </VAuth>

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Setting</span>
        </div>
      </div>
      <VAuth>
        <SidebarMenuItem
          to='/sysparam'
          icon='/media/icons/duotune/coding/cod001.svg'
          title='Sysparams'
          fontIcon='bi-layers'
        />
      </VAuth>
      <VAuth>
        <SidebarMenuItem
          to='/user'
          icon='/media/icons/duotune/coding/cod001.svg'
          title='User'
          fontIcon='bi-layers'
        />
      </VAuth>
      <VAuth>
        <SidebarMenuItem
          to='/role'
          icon='/media/icons/duotune/communication/com006.svg'
          title='Role'
          fontIcon='bi-layers'
        />
      </VAuth>
      <VAuth>
        <SidebarMenuItem
          to='/privileges'
          icon='/media/icons/duotune/general/gen051.svg'
          title='Privileges'
          fontIcon='bi-layers'
        />
      </VAuth>
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export {SidebarMenuMain}
